/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

/**
 * BCC Label keys for OneTrustCookieBanner component
 * These labels control all text content displayed in the cookie preference banner
 */
export const oneTrustLabelKeys = {
  // Button/Link Text
  acceptAllButtonText: 'label_cookie_banner_accept_all',
  rejectAllButtonText: 'label_cookie_banner_reject_all',
  managePreferencesLinkText: 'label_cookie_banner_manage_preferences',

  // Header
  bannerHeaderText: 'label_cookie_banner_header',

  // Main Content Messages
  bannerMainMessageText: 'label_cookie_banner_main_message',
  bannerBoldMessageText: 'label_cookie_banner_bold_message',

  // Information Links
  learnMoreText: 'label_cookie_banner_learn_more',
  privacyPolicyText: 'label_cookie_banner_privacy_policy',
  termsAndConditionsText: 'label_cookie_banner_terms_and_conditions',

  // Policy URLs
  privacyPolicyUrl: 'label_cookie_banner_privacy_policy_url',
  termsAndConditionsUrl: 'label_cookie_banner_terms_and_conditions_url',

  // Action Text
  clickBelowText: 'label_cookie_banner_click_below',
  clickHereText: 'label_cookie_banner_click_here',
  byUsingText: 'label_cookie_banner_by_using',

  // Connector Words
  orText: 'label_cookie_banner_or',
  andText: 'label_cookie_banner_and',
  cookiesText: 'label_cookie_banner_cookies',
  dotText: 'label_cookie_banner_period',
} as const;

export type OneTrustLabelKey = (typeof oneTrustLabelKeys)[keyof typeof oneTrustLabelKeys];
